import {Picture} from "@/shared/ui/Picture";
import styles from "../Editor.module.scss";

const ImageBlock = ({file, caption}) => {
    return (<Picture src={file?.url} alt={caption} classes={{root: styles.rePicture, image: styles.reImage}} />);
};

export default ImageBlock;
